module.exports = __webpack_public_path__ + "static/lich-acererak-4d8d68440589bff153b62f8d2df7826c.jpg";